<template>
  <div v-if="modelValue" class="gift-dialog" @click="closeDialog">
    <div class="dialog-content" @click.stop>
      <div class="title">
        <img class="app-logo" src="../assets/images/img_reward.png" alt="App Icon" />
      </div>
      
      <div class="message">
        <div class="message-text">{{ multiLan('collecting_reviews') }}</div>
      </div>

      <div class="app-info">
        <img class="app-icon" src="../assets/images/pwa_logo_192.png" alt="App Icon"/>
         <div class="right">
          <div class="app-name">{{ multiLan('app_name') }}</div>
          <div class="sub-app-name">{{ multiLan('app_name') }}</div>
          <div class="desc">
            <img src="../assets/images/ic_dun.png" alt="Google Play" />
            <div class="verified">{{ multiLan('verified_text') }}</div>
          </div>
         </div>
      </div>

      <div class="message-bottom">
        <img class="gift_icon" src="../assets/images/google_play_img.png" alt="App Icon"/>
        <div class="desc">{{ multiLan('review_reward_text') }}</div>
      </div>

      <button class="install-btn" @click="handleInstall">{{ multiLan('install_button') }}</button>
    </div>
  </div>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue'
import { multiLan } from '../assets/lan'

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['update:modelValue', 'install'])

const closeDialog = () => {
  emit('update:modelValue', false)
}

const handleInstall = () => {
  emit('install')
  closeDialog()
}
</script>

<style scoped>
.gift-dialog {
  position: fixed;
  top: 0;
  left: 0;

  width: calc(100% - 40px);
  padding: 0 20px;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}
.message-bottom {
  font-size: 16px;
  color: #000;
  line-height: 1.4;
  margin-bottom: 24px;
  padding: 0 8px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: row;

}
.gift_icon {
    width: 64px;
    height: 88px;
    margin-right: 8px;
  }
  .desc{
    font-size: 14px;
    font-weight: 500;
    text-align: start;
  }
.dialog-content {
  background: white;
  padding: 20px;
  border-radius: 20px;
  width: 90%;
  max-width: 340px;
  text-align: center;
}

.title {
  margin-bottom: 24px;
}

.main-title {
  font-size: 22px;
  font-weight: 600;
  color: #000;
  margin-bottom: 8px;
  letter-spacing: 1px;

}
.app-logo {
    width: 108px;
    height: 49px;
    margin-right: 8px;
  }

.sub-title {
  font-size: 15px;
  color: #666;
  letter-spacing: 0.5px;
}

.message {
  margin-bottom: 24px;
}

.message-text {
  font-size: 16px;
  color: #000;
  line-height: 1.4;
  font-weight: 600;
}

.app-info {
  background: white;
  border-radius: 16px;
  padding: 20px;
  margin-bottom: 24px;
  display: flex;
  flex-direction: row;
  align-items: center;
  border: 1px solid rgba(0, 0, 0, 0.12);
  box-shadow: 3px 3px 3px rgba(0, 0, 0, 0.08);
  .right {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-left: 12px;
    .app-name { 
      font-size: 16px;
      font-weight: 500;
      color: #000;;
    }
    .sub-app-name {
      color: #077c56;
      font-weight: 600;
    }
    .desc{
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-top: 4px;
      img {
        width: 14px;
        height: 16px;
        margin-right: 4px;
      }
    }
  }
}

.app-icon {
  width: 64px;
  height: 64px;
  border-radius: 16px;
  margin-bottom: 12px;
}

.app-name {
  font-size: 18px;
  font-weight: 500;
  color: #000;
  margin-bottom: 6px;
}

.verified {
  font-size: 14px;
  color: #666;
}



.install-btn {
  background: #077c56;
  color: white;
  border: none;
  padding: 14px;
  border-radius: 32px;
  font-size: 17px;
  width: 100%;
  cursor: pointer;
  font-weight: 500;
  transition: background-color 0.2s;
}

.install-btn:hover {
  background: #3367d6;
}
</style>
